/**
 * Top-level error boundary. Catches render errors, logs to console, and
 * offers a "Reload" button. Phase 5 can wire this to a Sentry-style hook.
 */

import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}
interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Friday crashed:', error, info)
  }
  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="flex h-full items-center justify-center p-12 text-center">
        <div className="max-w-md">
          <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
          <pre className="mb-4 overflow-auto rounded bg-surface-100 dark:bg-surface-800 p-3 text-left text-xs">
            {this.state.error.message}
          </pre>
          <button className="btn-primary" onClick={() => location.reload()}>Reload</button>
        </div>
      </div>
    )
  }
}
